import { ThemeProvider } from "styled-components";
import { useMemo } from "react";
import useToken from "antd/es/theme/useToken";

import { themeExtension } from "./theme";

const AntdThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const [, token] = useToken();

  const themeValue = useMemo(() => {
    return {
      ...token,
      ...themeExtension,
    };
  }, [token]);

  return <ThemeProvider theme={themeValue}>{children}</ThemeProvider>;
};

export default AntdThemeProvider;
